<template>
  <div class="leaderboardWrapper">
    <SeasonsPrizeFundBanner v-if="!$device.isMobile && modalView !== SeasonModalView.endedInfo" />
    <SeasonsPrizeFundBannerMobile v-if="$device.isMobile && modalView !== SeasonModalView.endedInfo" />
    <div v-if="isJackpot && !$device.isMobile" class="headersRow">
      <div class="ratingHeader">
        <span>{{ $t('coreRating') }}</span>
      </div>
      <div class="headersRight">
        <div class="pointsHeader">
          <span>{{ $t('corePoints') }}</span>
        </div>
        <div class="rewardHeader">
          <span>{{ $t('coreReward') }}</span>
        </div>
      </div>
    </div>
    <UIModalInnerContentWrapper
      ref="scrollContainer"
      class="contentWrapperExtraStyle maxHeightLeaderboard"
      @scroll="handleScroll"
    >
      <div v-if="isJackpot && $device.isMobile" class="headersRow">
        <div class="ratingHeader">
          <span>Rating</span>
        </div>
        <div class="headersRight">
          <div class="pointsHeader">
            <span>Point</span>
          </div>
          <div class="rewardHeader">
            <span>Reward</span>
          </div>
        </div>
      </div>
      <div class="leaderboardContainer">
        <div
          v-if="
            rewardsSeason &&
            Object.keys(rewardsSeason).length > 0 &&
            prizesPool &&
            prizesPool.length > 0 &&
            !isNoPrizeSticky &&
            !isJackpot
          "
          class="prize"
        >
          <span>{{ $t('seasonGrandPrize') }}:</span>
          <div v-for="token of rewardTokensData" :key="token.address" class="prizeItem">
            <img
              :src="
                rewardTokens?.[tokenMetaData(blockchain.contracts, token.address)?.name.contract as Tokens]?.toString()
              "
              alt=""
              width="36"
            />
            <span>{{ token.amount }}</span>
          </div>
        </div>
        <div
          v-else-if="
            rewardsSeason &&
            Object.keys(rewardsSeason).length > 0 &&
            isNoPrizeSticky &&
            leaderboardData?.length > Object.keys(rewardsSeason).length &&
            !isJackpot
          "
          class="noPrizeBanner filled"
        >
          {{ $t('noPrize') }}
        </div>
        <div
          v-else-if="!isJackpot"
          style="height: 45px; width: 100%; position: sticky; top: 0; background: #040e13"
        ></div>

        <div
          v-if="
            rewardsSeason &&
            Object.keys(rewardsSeason).length &&
            leaderboardData?.toString()?.length > 0 &&
            leaderboardData.length > Object.keys(rewardsSeason).length &&
            !isJackpot
          "
          ref="noPrizeEl"
          :style="{ order: Object.keys(rewardsSeason).length + 1 }"
          class="noPrize"
        >
          {{ $t('noPrize') }}
        </div>
        <div v-if="isShowStickyBgTop" :class="{ withoutPrizeRow: isJackpot }" class="stickyBgTop"></div>
        <div class="tw:flex tw:flex-col tw:gap-2 tw:p-4 tw:pt-0 leaderboardItemsContainer">
          <el-skeleton
            :loading="
              isLoadingLeaderboard ||
              isLoadingJackpotRewards ||
              (isJackpot &&
                typeof checkedHistoricalSeason !== 'number' &&
                (jackpotRewardsData === null || jackpotRewardsData === undefined) &&
                !!currentSeasonYear)
            "
            animated
            style="width: 100%; height: 100%"
          >
            <template #template>
              <div
                v-for="i in 10"
                :key="i"
                :style="{
                  width: '100%',
                  height: '60px',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 16px',
                  gap: '16px'
                }"
                class="skeleton-item"
              >
                <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0">
                  <el-skeleton-item :style="{ width: '30px', height: '20px', borderRadius: '4px' }" variant="text" />
                  <el-skeleton-item :style="{ width: '30px', height: '30px', flexShrink: 0 }" variant="circle" />
                  <el-skeleton-item
                    :style="{ width: isJackpot ? '180px' : '200px', height: '20px', borderRadius: '4px' }"
                    variant="text"
                  />
                </div>
                <div v-if="isJackpot" style="display: flex; align-items: center; gap: 12px; flex-shrink: 0">
                  <el-skeleton-item :style="{ width: '100px', height: '20px', borderRadius: '4px' }" variant="text" />
                  <el-skeleton-item :style="{ width: '120px', height: '20px', borderRadius: '4px' }" variant="text" />
                </div>
                <div v-else style="display: flex; align-items: center; gap: 8px; flex-shrink: 0">
                  <el-skeleton-item :style="{ width: '90px', height: '20px', borderRadius: '4px' }" variant="text" />
                </div>
              </div>
            </template>
            <template #default>
              <SeasonLeaderboardItem
                v-for="(item, i) of leaderboardData"
                :key="`${item[0]}${item[1]}`"
                :checked-historical-season="checkedHistoricalSeason"
                :class="{
                  withoutPrizeRow: isJackpot,
                  ownPosition: item[0] === address,
                  prizePosition:
                    Number(i) <
                    (isJackpot && typeof checkedHistoricalSeason !== 'number'
                      ? jackpotWinPlaces
                      : Object.keys(rewardsSeason || {}).length)
                }"
                :current-season-id="currentSeasonId!"
                :is-jackpot="isJackpot"
                :jackpot-score-in-year="
                  isJackpot && typeof checkedHistoricalSeason !== 'number'
                    ? BigNumber(item[1] || 0).toNumber()
                    : undefined
                "
                :leaderboard-length="leaderboardData.length"
                :own="item[0] === address"
                :pearl-amount="totalRewardsValueByPosition.get(+i + 1)?.toFixed(2)"
                :position="+i + 1"
                :score="BigNumber(item[1]).toNumber()"
                :selected-jackpot-year="selectedJackpotYear"
                :user-scores="findUserScores(item[0], Number(i) + 1)"
                @change-show-sticky-bg-top="
                  (isShow) => {
                    isShowStickyBgTop = isShow;
                  }
                "
                @change-show-sticky-bg-bottom="
                  (isShow) => {
                    isShowStickyBgBottom = isShow;
                  }
                "
                @jackpot-item-click="handleJackpotItemClick"
              />
            </template>
          </el-skeleton>
        </div>

        <div v-if="isShowStickyBgBottom" :style="{ order: leaderboardData.length + 4 }" class="stickyBgBottom"></div>
      </div>
    </UIModalInnerContentWrapper>
    <JackpotRewardModal
      v-if="isJackpot"
      v-model="isJackpotRewardModalOpen"
      :leaderboard-position="selectedPosition"
      :rewards="selectedPositionRewards"
      :show-claim-button="canShowJackpotClaimButton && isSelectedPositionOwn"
      @claim="handleClaimJackpotRewards"
    />
  </div>
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#app';
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { BigNumber } from 'bignumber.js';
import { ZeroAddress } from 'ethers';
import { Season__factory, SeasonRewardsYear1__factory } from 'public/abi/evm/types';
import rewardTokens from '~/public/img/tokens';
import type { Reward, SeasonsUserScores } from '~/types/season';
import { SeasonModalView } from '~/types/season';
import {
  apiUrls,
  Tokens,
  TokenPrices,
  NFTPrices,
  LEADERBOARD_REWARDS,
  LEADERBOARD_REWARDS_100,
  NFT_NAME_TO_PRICE_KEY
} from '~/utils/constants';
import { tokenMetaData } from '~/utils';
import { JackpotRewardModal } from '~/widgets/jackpot/reward/ui/assets';
import SeasonsPrizeFundBanner from '~/components/Season/SeasonsPrizeFundBanner.vue';
import SeasonsPrizeFundBannerMobile from '~/components/Season/SeasonsPrizeFundBannerMobile.vue';

// TODO: rewardsConfig data from the blockchain could be removed. Use rewardsSeason, rewardsJackpot instead
// FIXME: fix wrong comparison issues, like on line 106, typeof (number | undefined) !== "number" - why?
const emit = defineEmits(['loadingSwitcher']);
const { blockchain, apiUrl, jackpotWinPlaces } = useEnvs();
const { getProvider } = useProvider();
const { address } = useWeb3ModalAccount();
const seasonId = inject<Ref<number>>('currentSeasonId');
const seasonsCount = inject<Ref<number>>('seasonsCount');
const jackpotRewardsData = inject<Ref<any>>('jackpotRewardsData') ?? ref([]);
const isLoadingJackpotRewards = inject<Ref<boolean>>('isLoadingJackpotRewards', ref(false));
const canShowJackpotClaimButton = inject<Ref<boolean>>('canShowJackpotClaimButton', ref(false));
const claimJackpotRewards = inject<() => Promise<boolean>>('claimJackpotRewards');
const config = useRuntimeConfig();
const modalView = inject<Ref<SeasonModalView>>('modalView', ref(SeasonModalView.leaderboard));

const { checkedHistoricalSeason, isJackpot } = defineProps<{ checkedHistoricalSeason?: number; isJackpot: boolean }>();
const currentSeasonId = computed(() =>
  typeof checkedHistoricalSeason !== 'number' ? seasonId?.value : checkedHistoricalSeason
);

const noPrizeEl = ref<HTMLElement | null>(null);

const isShowStickyBgTop = ref(false);
const isShowStickyBgBottom = ref(false);

const isNoPrizeSticky = ref(false);

const isJackpotRewardModalOpen = ref(false);
const selectedPosition = ref(0);

const { setScrolling } = useLeaderboardScroll();

let scrollTimeout: NodeJS.Timeout | null = null;

const handleScroll = () => {
  setScrolling(true);

  if (scrollTimeout) {
    clearTimeout(scrollTimeout);
  }

  scrollTimeout = setTimeout(() => {
    setScrolling(false);
  }, 150);
};

const handleJackpotItemClick = (position: number) => {
  if (!isJackpot) return;
  selectedPosition.value = position;
  isJackpotRewardModalOpen.value = true;
};

const handleClaimJackpotRewards = async () => {
  if (!claimJackpotRewards) return;

  const success = await claimJackpotRewards();
  if (success) {
    isJackpotRewardModalOpen.value = false;
  }
};

const leaderboardHistoricalSeasonsData = inject<Ref<any[][]>>('leaderboardHistoricalSeasonsData');

const { data: userScoresSeason } = useFetch<SeasonsUserScores[]>(
  () => apiUrls.seasons.userScores(BigNumber(currentSeasonId.value || 0).toNumber()),
  {
    baseURL: apiUrl,
    immediate: true,
    watch: [address, currentSeasonId],
    onRequest() {
      emit('loadingSwitcher');
    },
    onResponse() {
      emit('loadingSwitcher');
    }
  }
);

const seasonContract = Season__factory.connect(blockchain.contracts.season, getProvider());
const currentSeasonYear = inject<ComputedRef<number>>('currentSeasonYear');
const selectedJackpotYear = inject<Ref<number>>('selectedJackpotYear');

const { data: rewardsSeason } = useFetch<Record<string, Reward[]>>(
  () => apiUrls.seasons.positionsRewards(BigNumber(currentSeasonId.value || 0).toNumber()),
  {
    baseURL: apiUrl,
    immediate: true,
    watch: [address, currentSeasonId],
    onRequest() {
      emit('loadingSwitcher');
    },
    onResponse() {
      emit('loadingSwitcher');
    }
  }
);

const { data: rewardsJackpot } = useFetch<Record<string, Reward[]>>(
  () => apiUrls.jackpot.positionsRewards(BigNumber(currentSeasonYear?.value || 0).toNumber()),
  {
    baseURL: apiUrl,
    watch: [address, () => currentSeasonYear?.value],
    onRequest() {
      emit('loadingSwitcher');
    },
    onResponse() {
      emit('loadingSwitcher');
    }
  }
);

const { data: userScoresJackpot } = useFetch<SeasonsUserScores[]>(
  () => apiUrls.jackpot.userScores(currentSeasonYear?.value!),
  {
    baseURL: apiUrl,
    immediate: true,
    watch: [address, () => currentSeasonYear?.value]
  }
);

const rewardsData = computed(() =>
  isJackpot && typeof checkedHistoricalSeason !== 'number' ? userScoresJackpot.value : userScoresSeason.value
);

const isLoadingLeaderboard = ref(false);
const leaderboardData = asyncComputed(async () => {
  if (!seasonsCount || !seasonId) {
    return [];
  }

  if (isJackpot && typeof checkedHistoricalSeason !== 'number') {
    try {
      isLoadingLeaderboard.value = true;
      return await seasonContract?.getUserScoresBySeasonYear(currentSeasonYear?.value || 0, ZeroAddress, 1000);
    } finally {
      isLoadingLeaderboard.value = false;
    }
  } else {
    // Проверяем, является ли выбранный сезон текущим
    const isCurrentSeason =
      typeof checkedHistoricalSeason === 'number' ? checkedHistoricalSeason === Number(seasonId.value) : true;

    // Если это текущий сезон, загружаем данные из контракта напрямую
    if (isCurrentSeason) {
      try {
        isLoadingLeaderboard.value = true;
        return await seasonContract?.getUserScoresBySeason(Number(seasonId.value), ZeroAddress, 1000);
      } finally {
        isLoadingLeaderboard.value = false;
      }
    } else {
      // Для исторических сезонов используем данные из leaderboardHistoricalSeasonsData
      if (typeof checkedHistoricalSeason !== 'number') {
        return [];
      }
      const seasonIndex = checkedHistoricalSeason - 1;
      return leaderboardHistoricalSeasonsData?.value[seasonIndex]?.[0] || [];
    }
  }
});

// Watch для установки loading состояния при переключении года в jackpot режиме
// Удален, так как isLoadingLeaderboard управляется внутри asyncComputed для leaderboardData

const rewardsConfig = asyncComputed(async () => {
  const seasonYearContract = SeasonRewardsYear1__factory.connect(
    (config.public.env === 'prod' ? 41 : 1006) < (currentSeasonId.value || 0)
      ? blockchain.contracts.SEASON_REWARDS_YEAR_2
      : blockchain.contracts.SEASON_REWARDS_YEAR_1,
    getProvider()
  );

  return isJackpot ? null : await seasonYearContract?.getSeasonRewardsConfig(currentSeasonId.value || 0);
});

const rewardTokensData = computed(() => {
  const items = rewardsConfig.value?.map((item) => ({
    address: item[0],
    amount: new BigNumber(String(item[1])).shiftedBy(-18)
  }));
  if (!items?.length) return [];
  const byAddress = items.reduce<Record<string, BigNumber>>((acc, { address, amount }) => {
    acc[address] = (acc[address] ?? new BigNumber(0)).plus(amount);
    return acc;
  }, {});
  return Object.entries(byAddress).map(([address, amount]) => ({
    address,
    amount: amount.toString()
  }));
});

const prizesPool = computed(() => {
  if (!rewardsSeason.value) {
    return;
  }

  return rewardTokensData.value.map((token: { address: string; amount: string }) =>
    Object.values(rewardsSeason.value || {})
      .flat()
      .filter((entry) => entry.tokenAddress === token.address)
      .reduce((prev, cur) => prev + cur.amount, 0)
  );
});

onMounted(() => {
  if (noPrizeEl.value) {
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].rootBounds &&
          entries[0].intersectionRect.bottom <= entries[0].rootBounds.top + 50 &&
          entries[0].intersectionRect.top === entries[0].rootBounds.top
        ) {
          isNoPrizeSticky.value = true;
        } else {
          isNoPrizeSticky.value = false;
        }
      },
      { threshold: [0.5, 0.75, 1], root: noPrizeEl.value?.parentNode?.parentNode as HTMLElement }
    );

    intersectionObserver.observe(noPrizeEl.value as HTMLElement);
  }

  onBeforeUnmount(() => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
  });
});

/**
 * Maps token key to TokenPrices enum value
 */
const getTokenPrice = (tokenKey: Tokens | string | null | undefined): number => {
  if (!tokenKey) return 0;

  // Normalize token key: convert camelCase to UPPER_SNAKE_CASE for comparison
  const normalizedKey = tokenKey
    .replace(/([A-Z])/g, '_$1')
    .toUpperCase()
    .replace(/^_/, '') as keyof typeof TokenPrices;

  // Direct mapping from token keys to prices
  const tokenPriceMap: Record<string, number> = {
    PEARL: TokenPrices.PEARL,
    BLACK_PEARL: TokenPrices.BLACK_PEARL,
    COAL: TokenPrices.COAL,
    GOLD_ORE: TokenPrices.GOLD_ORE,
    WOOD: TokenPrices.WOOD,
    IRON_ORE: TokenPrices.IRON_ORE,
    SAND: TokenPrices.SAND,
    CLAY: TokenPrices.CLAY
  };

  return tokenPriceMap[normalizedKey] ?? 0;
};

/**
 * Calculates total value of all rewards (tokens + NFTs) for each position
 */
const totalRewardsValueByPosition = computed(() => {
  if (!jackpotRewardsData.value || !Array.isArray(jackpotRewardsData.value)) {
    return new Map<number, number>();
  }

  const is2026 = isJackpot && selectedJackpotYear?.value === 2026;
  const rewardsMap = is2026 ? LEADERBOARD_REWARDS_100 : LEADERBOARD_REWARDS;
  const maxPosition = is2026 ? 100 : 30;

  const map = new Map<number, number>();

  jackpotRewardsData.value.forEach((positionRewards: any) => {
    if (
      !positionRewards?.rewards ||
      !Array.isArray(positionRewards.rewards) ||
      positionRewards.position > maxPosition
    ) {
      return;
    }

    let totalValue = 0;

    // Calculate tokens value
    positionRewards.rewards.forEach((reward: any) => {
      if (reward.isNFT || reward.isNft) {
        // NFT values are calculated separately from rewardsMap
        return;
      }

      // Get token type from address
      const tokenData = tokenMetaData(blockchain.contracts, reward.token);
      const tokenKey = tokenData?.name?.contract;
      const tokenPrice = getTokenPrice(tokenKey);
      const amount = parseFloat(reward.amount || '0');

      totalValue += amount * tokenPrice;
    });

    // Calculate NFTs value from rewardsMap
    const positionNFTs = rewardsMap[positionRewards.position];
    if (positionNFTs && Array.isArray(positionNFTs)) {
      positionNFTs.forEach((nftName) => {
        const priceKey = NFT_NAME_TO_PRICE_KEY[nftName];
        if (priceKey && NFTPrices[priceKey]) {
          totalValue += NFTPrices[priceKey];
        }
      });
    }

    map.set(positionRewards.position, totalValue);
  });

  return map;
});

const selectedPositionRewards = computed(() => {
  if (!jackpotRewardsData.value || !Array.isArray(jackpotRewardsData.value) || !selectedPosition.value) {
    return [];
  }

  const positionData = jackpotRewardsData.value.find((item: any) => item.position === selectedPosition.value);

  if (!positionData?.rewards || !Array.isArray(positionData.rewards)) {
    return [];
  }

  return positionData.rewards.map((reward: any) => ({
    token: reward.token,
    isNFT: reward.isNFT ?? reward.isNft ?? false,
    amount: reward.amount
  }));
});

const findUserScores = (address: string, positionIndex: number) => {
  if (!rewardsData.value || !Array.isArray(rewardsData.value)) return;

  const userRewards = rewardsData.value.find((item) => item.address === address?.toLowerCase()) as SeasonsUserScores;

  if (isJackpot && rewardsJackpot.value) {
    const jackpotRewards = rewardsJackpot.value as Record<string, Reward[]>;
    const rewards = jackpotRewards[positionIndex] || jackpotRewards[String(positionIndex)];
    return { ...userRewards, rewards };
  }

  if (!isJackpot && rewardsSeason.value) {
    const seasonRewards = rewardsSeason.value as Record<string, Reward[]>;
    const rewards = seasonRewards[positionIndex] || seasonRewards[String(positionIndex)];
    return { ...userRewards, rewards };
  }
};

const getUserPosition = computed(() => {
  if (!leaderboardData.value || !address.value || !isJackpot) return null;

  const userIndex = leaderboardData.value.findIndex(
    (item: string[]) => item[0]?.toLowerCase() === address.value?.toLowerCase()
  );
  if (userIndex === -1) return null;

  return userIndex + 1;
});

const isSelectedPositionOwn = computed(() => {
  if (!getUserPosition.value || !selectedPosition.value) return false;
  return selectedPosition.value === getUserPosition.value;
});

watch(
  [() => isJackpot, () => canShowJackpotClaimButton.value, getUserPosition],
  ([newIsJackpot, newCanShowClaim, newUserPosition]) => {
    if (
      newIsJackpot &&
      newCanShowClaim &&
      newUserPosition !== null &&
      newUserPosition <= (selectedJackpotYear?.value === 2026 ? 100 : 30) &&
      !isJackpotRewardModalOpen.value
    ) {
      selectedPosition.value = newUserPosition;
      isJackpotRewardModalOpen.value = true;
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.leaderboardWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;

  @media screen and (max-width: 767px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
}

.headersRow {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  position: relative;

  font-weight: 700;
  font-size: 14px;
  line-height: 100%;

  @media screen and (max-width: 767px) {
    min-width: 600px;
    width: max-content;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 10;
    background: #040e13;
    margin-bottom: 0;
    padding-bottom: 4px;
    border-radius: 10px 10px 0 0;
  }

  @media screen and (min-width: 768px) {
    position: relative;
    width: 100%;
  }
}

.ratingHeader {
  width: 200px;
  padding: 6px;
  background: linear-gradient(to bottom, #17343e 0%, #010303 100%);
  border: 1px solid #3b7285;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;
  margin-left: 190px;
  flex-shrink: 0;

  span {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    font-family: Grenze, sans-serif;
    white-space: nowrap;
  }

  @media screen and (max-width: 767px) {
    padding: 4px;
    margin-left: 36px;
    width: 200px;
    min-width: 200px;

    span {
      font-size: 18px;
    }
  }
}

.headersRight {
  display: flex;
  gap: 62px;
  align-items: flex-start;
  margin-right: 46px;
  flex-shrink: 0;

  @media screen and (max-width: 767px) {
    margin-right: 0;
    gap: 40px;
    flex: 1;
    justify-content: flex-end;
  }
}

.pointsHeader {
  width: 90px;
  min-width: 90px;

  @media screen and (max-width: 767px) {
    min-width: 100px;
  }
}

.rewardHeader {
  width: 140px;
  min-width: 140px;

  @media screen and (max-width: 767px) {
    min-width: 150px;
  }
}

.pointsHeader,
.rewardHeader {
  padding: 6px;
  background: linear-gradient(to bottom, #17343e 0%, #010303 100%);
  border: 1px solid #3b7285;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;

  span {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    font-family: Grenze, sans-serif;
  }

  @media screen and (max-width: 767px) {
    padding: 4px;

    span {
      font-size: 18px;
    }
  }
}

.contentWrapperExtraStyle {
  border-radius: 12px;
  height: 100%;
  max-height: 50vh;

  &.maxHeightLeaderboard {
    max-height: 44dvh;

    @media screen and (max-height: 880px) {
      max-height: 42dvh;
    }
  }

  @media screen and (max-width: 560px) {
    width: 100%;
    max-height: 100%;
    overflow-x: auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    margin: 0;

    &::-webkit-scrollbar {
      height: 4px;
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 2px;
    }
  }
}

.leaderboardWrapper:has(.headersRow) {
  :deep(.modalInnerWrapper) {
    margin-top: 0;
  }
}

.leaderboardContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 767px) {
    min-width: 600px;
    width: max-content;
  }

  .prizePosition {
    border-color: #867927;
  }

  .filled {
    background: linear-gradient(180deg, #071821 0%, #040e13 100%);
  }

  .prize {
    display: flex;
    column-gap: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    justify-content: center;
    align-items: center;
    position: sticky;
    flex-wrap: wrap;
    top: 0;
    background: linear-gradient(180deg, #071821 0%, #040e13 100%);
    z-index: 2;

    @media screen and (max-width: 560px) {
      min-height: 50px;
    }

    & * {
      color: #ffce1e;
      font-family: Grenze, sans-serif;
      font-size: 22px;
    }
  }

  .prizeHeading {
    @media screen and (max-width: 767px) {
      width: 100%;
      text-align: center;
    }
  }

  .noPrizeBanner,
  .noPrize {
    padding: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: #88e1ff;
  }

  .noPrizeBanner {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 2;
  }

  .prizeItem {
    display: flex;
    gap: 5px;
    align-items: center;
  }
}

.stickyBgTop,
.stickyBgBottom {
  position: sticky;
  width: 100%;
  background: #040e13;
  animation: fade-in 0.3s ease-in forwards;
  z-index: 1;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.stickyBgTop {
  top: 45px;
  height: 50px;

  @media screen and (max-width: 767px) {
    top: 75px;
  }

  &.withoutPrizeRow {
    height: 60px;
    top: -10px;
  }
}

.stickyBgBottom {
  bottom: -28px;
  height: 60px;
}

.leaderboardItemsContainer {
  @media screen and (max-width: 767px) {
    min-width: max-content;
    width: max-content;
  }

  .skeleton-item {
    background: linear-gradient(180deg, #071821 0%, #040e13 100%);
    border: 1px solid #3b7285;
    border-radius: 12px;
    margin-bottom: 8px;

    :deep(.el-skeleton__item) {
      background: linear-gradient(
        90deg,
        rgba(59, 115, 133, 0.3) 25%,
        rgba(59, 115, 133, 0.5) 50%,
        rgba(59, 115, 133, 0.3) 75%
      );
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s ease-in-out infinite;
    }
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>

<style>
.ownPosition {
  position: sticky;
  top: 50px;
  bottom: 10px;
  z-index: 11;

  @media screen and (max-width: 560px) {
    top: 85px;
  }
}

.ownPosition.withoutPrizeRow {
  top: 5px;

  @media screen and (max-width: 560px) {
    top: 45px;
  }
}
</style>
